/**
 * TODO : Load / Save from locaStorage or cookies
 */
 fx.ns("models", class Settings extends fx.Model {

    constructor(data)
    {
        super(data);
    }

    toggleGridMode()
    {
        this.gridmode = !this.gridmode; 
        this.event("grid-notification", {gridmode: this.gridmode});
    }

    get defaults()
    {
        return {
            precision : 5, 
            tolerance : 2, 
            gridmode : true,
            warningShowDelay : 3000,
            minDensity : 40, // DPI
            maxHistoryActionsStored : 50,
            numberOfSavings : 5,
            maxUploads : 5,
            maxAIProcesses : 3,
            noRevokePictures : 1000,
            coverTimeOut : 10000,
            coverImageTimeOut : 5000,
            socialFileSize : 1000,
            numMaxPhoto : 4,
            delayProposeRegister : 300000,
            debugging : false,

            // PhotoCurator (browser-side album creation, see js/data/curator)
            curatorPhotosPerPage : 3,        // the book grows towards this average
            curatorMaxPhotosPerPage : 6,
            curatorMaxGroupSize : 12,        // a moment bigger than this is split on its largest gap
            curatorHeroMinScore : 0.45,      // a moment opens on its best photo alone above this score
            curatorPageMargin : 15,          // white margin around the photos, page units (0 : full bleed)
            curatorMaxCropLoss : 0.35,       // layouts are stretched to the page as long as no photo loses more than this
            curatorCoverMargin : 0.07,       // white frame around the cover photo, fraction of the page width
            curatorCoverPhotoHeight : 0.75,  // cover photo height, fraction of the page height
            curatorCoverFont : "Lora",
            curatorCoverTitleFontSize : 10,
            curatorCoverTitleColor : "rgb(108, 108, 107)",
            curatorCoverSubtitleFontSize : 6,
            curatorCoverSubtitleColor : "rgb(0, 0, 0)",
            curatorDateFont : "Lora",        // date of the pages where the day changes : "Le jeudi 17" / "Septembre 2026"
            curatorDateDayFontSize : 7,
            curatorDateMonthFontSize : 5,
            curatorDateColor : "rgb(0, 0, 0)",
            curatorImageSize : 256,          // long side of the working canvas
            curatorFaceMinConfidence : 0.25,   // BlazeFace score below which a detection is dropped : low on purpose, so that small or turned faces on 256 px thumbs are kept, the area and keypoints filters below dropping most false positives
            curatorFaceMinSuppression : 0.25, // overlap above which two boxes are merged (non-max suppression)
            curatorFaceMinArea : 0.005,       // normalized width * height (~7% of the width) : smaller faces (background passers-by) are ignored
            curatorFaceCheckKeypoints : true, // eyes above the mouth and apart enough, else not a face
            curatorFaceBundleUrl : "/app/js/vendors/mediapipe/vision_bundle.js",
            curatorFaceModelUrl : "/app/js/vendors/mediapipe/models/blaze_face_short_range.tflite",
            // wasm runtime (simd + nosimd variants of @mediapipe/tasks-vision 1.0.1, fetched on first use)
            curatorFaceWasmPath : "/app/js/vendors/mediapipe/wasm",
            curatorCoverShapeMinArea : 0.65, // a cover layout shape covering more of the page than this is repeated around the cover photo (the frames of the collections start at 0.69)
            curatorCoverShapeMargin : 10,    // how much bigger than the photo that shape is, in page units
            curatorCoverShapePhotoShrink : 0.1, // a collection framing its cover with a shape and showing no photo of its own gets a photo this much smaller
            curatorCoverShapeTitleLift : 10,    // and its title and subtitle come up by this much

            // PhotoEnhancer (automatic colour correction for print, screenshot app only, creations.to_enhance = 1, see js/data/enhance)
            // paper model : to calibrate once by comparing a real print with the screen.
            // starting values for an HP Indigo on 200 g/m² gloss coated paper : very little dot gain (calibrated press),
            // wide gamut, excellent detail, black a bit less deep than offset
            enhancePaperBlack : 0.05,        // deepest black the ink reaches (0 = screen black)
            enhancePaperWhite : 0.97,        // white of the bare paper (1 = screen white)
            enhanceDotGain : 1.05,           // darkening of the mid tones (dot gain)
            enhancePaperSaturation : 0.93,   // part of the saturation the paper gives back
            enhancePaperBlur : 0.25,         // softening by the ink and the screening (px for a 3000 px long side)
            // compensation applied to every photo
            enhanceCompensation : 1,         // 1 = exact inverse of the paper model, 0 = none
            enhancePunch : 0.08,             // light S curve + vibrance, for the relief the paper flattens
            enhanceSharpen : 0.4,            // strength of the sharpening (0 = none)
            enhanceSharpenRadius : 0.7,      // radius in px for a 3000 px long side (scaled to the photo)
            enhanceSharpenThreshold : 3,     // luminance differences (out of 255) left alone : noise, skin grain, skies
            // correction of each photo
            enhanceDarkThreshold : 0.36,     // median luminance under which a photo is brightened
            enhanceTargetMedian : 0.43,      // median luminance aimed at for a dark photo
            enhanceGammaMin : 0.78,          // strongest brightening allowed
            enhanceDullThreshold : 0.13,     // mean chroma under which a photo gets some vibrance
            enhanceGrayThreshold : 0.035,    // mean chroma under which a photo is black and white (no vibrance)
            enhanceVibranceMax : 0.25,       // vibrance given to the dullest photo
            enhanceVibranceCap : 0.6,        // total vibrance never goes above this
            // processing
            enhanceAnalysisSize : 64,        // side of the thumbnail the photo is analysed on
            enhanceMaxSize : 6000,           // long side above which the photo is scaled down before being corrected (0 : never)
            enhanceJpegQuality : 0.95,
            enhanceKeepCustomerLook : true   // a photo the customer gave an effect or brightness / saturation / contrast keeps that look : paper compensation only
        }
    }
}); 